// extracted by mini-css-extract-plugin
export default {"container":"AttachmentForm-module_container__jOPLm","fileContainer":"AttachmentForm-module_fileContainer__ax7El"};